import Vue from 'vue'
import { DAY } from '@shared/utils/storage'
import { StorageService } from './storage'
import { stagesService } from './stages'


export const ProductsService = StorageService.extend({
  key: '#calendar-products',
  storageParams: { expired: DAY },

  urls: {
    REACTIONS: '/api/calendar/products/reactions/',
    LIKE: '/api/products/:id/like/?cell_id=:cell_id',
    DISLIKE: '/api/products/:id/dislike/?cell_id=:cell_id&replace_with=:replace_with',
    ALLERGY: '/api/products/:id/allergic/?cell_id=:cell_id&replace_with=:replace_with',
    ALTERNATIVES: '/api/products/:id/alternatives/',

    VARIANTS: '/api/cells/:cell/variants/',
    SELECT_PRODUCT: '/api/cells/:cell/select/',
    SELECT_GROUP: '/api/cells/:cell/select-group/',
  },

  data() {
    return {
      reactions: {},
      liked: {},
      disliked: {},
      allergic: {},
      alternatives: {},

      // allergyCounter: 0,
      // allergyCounterInitial: -1,

      variants: {},
    }
  },

  created() {
    this.updateReactions()

    // stagesService.$on('initializeStage', config => {
    //   this.allergyCounter = this.reactions.allergic.length
    //   this.allergyCounterInitial = this.reactions.allergic.length
    // })
  },

  methods: {
    updateReactions() {
      let counter = this.allergyCounter

      this.retreiveCollection(this.getUrl('REACTIONS'), 'reactions')
        .then(data => {
          for (let type in data) {
            for (let item of data[type]) {
              this.setCollectionItem(type, item.id, item)
            }
          }

          // this.allergyCounter = this.reactions.allergic.length
          // if (this.allergyCounterInitial == -1) {
          //   this.allergyCounterInitial = this.allergyCounter
          // }

          // if (
          //   counter < this.allergyCounter &&
          //   this.allergyCounter - this.allergyCounterInitial >= 2
          // ) {
          //   this.$emit('frequentAllergy')
          // }
        })
    },

    cleanAlternatives() {
      this.alternatives = {}
    },

    like(id, cell_id='') {
      return this.sendData(
        this.getUrl('LIKE', { id, cell_id }),
        {},
        data => {
          this.updateReactions()
          this.cleanAlternatives()
          this.updateCache()

          return data
        }
      )
    },

    dislike(id, cell_id='', replace_with='') {
      return this.sendData(
        this.getUrl('DISLIKE', { id, cell_id, replace_with }),
        {},
        data => {
          this.updateReactions()
          this.cleanAlternatives()
          this.updateCache()

          return data
        }
      )
    },

    allergy(id, cell_id='', replace_with='') {
      return this.sendData(
        this.getUrl('ALLERGY', { id, cell_id, replace_with }),
        {},
        data => {
          this.updateReactions()
          this.cleanAlternatives()
          this.updateCache()

          return data
        }
      )
    },

    getAlternatives(id) {
      return this.retreiveCollectionItem(
        this.getUrl('ALTERNATIVES', { id }), 'alternatives', id
      )
    },

    getVariants(cell) {
      this.variants = {}

      return this.retreiveCollectionItem(
        this.getUrl('VARIANTS', { cell }), 'variants', cell
      )
    },

    selectProduct(id, cell) {
      return this.sendData(
        this.getUrl('SELECT_PRODUCT', { cell }),
        { id },
        data => {
          return data
        }
      )
    },

    selectGroup(id, cell) {
      return this.sendData(
        this.getUrl('SELECT_GROUP', { cell }),
        { id },
        data => {
          return data
        }
      )
    }
  }
})

export const productsService = new ProductsService({})



// WEBPACK FOOTER //
// ./src/js/shared/services/products.js